<div class="wrtext" [ngClass]="{'loading': loading}">
  <h1 i18n>Rejestracje żetonowe</h1>

  <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>

  <ng-container *ngIf="!loading">
    <router-outlet></router-outlet>
  </ng-container>
</div>
